import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';

const NoPlan = (plan) => {

    const navigate = useNavigate();

    const buyNewPlan = () => {
        navigate('/');
    };

  return (
    <div className="no-plan plan-card">
        <div className="plan-details">
            <img src="/assets/noplan.svg" alt="No Plan" className="no-plan" />
            <p className='info'>You are Yet to Purchase a Road Side Assistance Plan</p>
            <div className='btn-section'>
                {/* <Link to="/" className="orders-link">Go to Home Page</Link> */}
                <button onClick={buyNewPlan} className="buy-plan">Buy a New Plan</button>
            </div>
        </div>
        <Footer noPlan={true}/>
    </div>
    
  );
};

export default NoPlan;
